var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dt',{class:_vm.className},[_c('app-text',{attrs:{"color":_vm.text.color.burnt,"weight":_vm.text.weight.bold,"height":_vm.lineHeight,"spacing":_vm.text.spacing.spacing1}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }